export enum Permission {
  UPDATE_PROPERTY = 'UPDATE_PROPERTY',
  UPDATE_USER_ROLE_TYPE = 'UPDATE_USER_ROLE_TYPE',
  UPDATE_CALL_CENTER_AGENT_INFORMATION_OWN_ACCOUNT = 'UPDATE_CALL_CENTER_AGENT_INFORMATION_OWN_ACCOUNT',
  READ_CALL_CENTER_AGENT_INFORMATION_OTHER_ACCOUNT = 'READ_CALL_CENTER_AGENT_INFORMATION_OTHER_ACCOUNT',
  UPDATE_CALL_CENTER_AGENT_INFORMATION_OTHER_ACCOUNT = 'UPDATE_CALL_CENTER_AGENT_INFORMATION_OTHER_ACCOUNT',
  CREATE_CONFERENCE_PARTICIPANT_MANAGER = 'CREATE_CONFERENCE_PARTICIPANT_MANAGER',
}
